module.exports = __webpack_public_path__ + "img/LightspeedRetail.17a551fc.svg";